
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Options({
  name: 'WorkCenterErrorDialog',
})
export default class WorkCenterErrorDialog extends Vue {
  @Prop({ type: Boolean, default: false }) modelValue!: boolean
  @Prop({ type: String, default: '' }) errorMessage!: string

  get dialogVisible() {
    return this.modelValue
  }

  set dialogVisible(value: boolean) {
    this.$emit('update:modelValue', value)
  }

  handleClose() {
    this.dialogVisible = false
  }
}
